import React, { Component } from 'react';
import '../../styles/style.css'
import { Grid, Row, Col } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux'

import { authActions } from '../../../core/auth'

const styles = {
  spacetop: {
      height: '20px'
  },
}
class SignIn extends Component {
  handleFormSubmit = (values) => {
    this.props.clickEmailSignIn(values)
  }

  renderField = ({ input, label, type, meta: { touched, error } }) => (
    <fieldset>
      <div>
        <TextField {...input} placeholder={label} type={type}
          errorText={touched && error && <span>{error}</span>}
        />
      </div>
    </fieldset>
  )

  render() {
    return (
      <div>
        <div className="subheader">
          <h4>Sign-In</h4>
        </div>
        <Grid>
          <Row>
            <Col xs={12} md={8} mdOffset={2}>
                <div style={styles.spacetop}></div>
                <p>
                <b>Housing registration for Rhodes College is now CLOSED.</b> You may log into your
                account to view your housing assignment. Assignments for the 2nd sophomore draw
                period will be posted on 3/31.
                </p>
                <form onSubmit={this.props.handleSubmit(this.handleFormSubmit)}>
                  <Field name="email" type="text" component={this.renderField} label="Email" />
                  <Field name="password" type="password" component={this.renderField} label="Password" />

                  <RaisedButton type="submit" label="Sign In" primary={true} />
                </form>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}


//=====================================
//  CONNECT
//-------------------------------------

export default connect(null, authActions)(reduxForm({
  form: 'sign-in'
})(SignIn))



// WEBPACK FOOTER //
// ./src/views/pages/sign-in/index.js